import { Button } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDuplicateQuote } from '../../hooks/useDuplicateQuote'

export const DuplicateQuoteButton = (): ReactElement => {
  const { t } = useTranslation()
  const { duplicateQuote } = useDuplicateQuote()

  const handleDuplicateInvoiceButtonClick = useCallback(() => {
    duplicateQuote()
  }, [duplicateQuote])

  return (
    <Button icon="copy" onClick={handleDuplicateInvoiceButtonClick} variant="outlined">
      {t('external_invoices.view.duplicate')}
    </Button>
  )
}
